import Layout from '../../components/Layout/Layout';
import { buildPrimaryPostPage } from '../../util/buildPrimaryPostPage';

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'CAREERS',
        basePath: '/careers',
        LayoutComponent: Layout,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
